import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid/")({
  loader: () => {
    throw redirect({
      to: "./profile/details",
      from: "/gym/$venueUuid/events/series/$leagueUuid/",
    });
  },
});
